import React from 'react'
import classNames from 'classnames'

const BarRenderer = ({ color, column }) => {

  const barClasses = classNames(
    `bar-renderer__line bar-renderer__level--${color}`
  )

  return (
    <div className='bar-renderer__container'>
      <div className='bar-renderer__text'>{column.text}</div>
        <div className='bar-renderer__level'>
            <div
              className={barClasses}
              style={{ width: `${column.width}%` }}
            />
        </div>
    </div>
  )
}

export default BarRenderer